﻿import C from './Constants';

export default class DataStorage {  
    constructor(eventId, isSeason) {
        this.eventId = eventId;
        this.isSeason = isSeason;
        this._confirmedSeats = []; //Manuellt valda platser
        this.state = C.STATE_SEATS_GROUPED;
  }

    init() {
        return this._loadBasket().then((data) => {
            return this.cart = data.filter(itm => itm.seatedTicket && itm.eventId == this.eventId && itm.isSeason == this.isSeason);
        });
    }

    clearSectionData() {
        this.sectionData = null;
        this.section = null;
    }
    
    ClearSelectedSeatId() {
        this.selectedSeat = null;
    }

    SetSelectedSeat(seat) {        
        this.selectedSeat = seat;        
    }

  GetCart() {
    return this.cart.filter(itm => itm.seatedTicket && itm.eventId == this.eventId && itm.isSeason == this.isSeason);
  }

  GetCountInCurrentArena() {
    if (this.cart != undefined && this.cart!=null)
      return this.cart.filter(itm => itm.seatedTicket && itm.eventId == this.eventId && itm.isSeason == this.isSeason).length;
    return 0;
  }
  GetCountInCurrentSection(code) {
    if (this.cart != undefined && this.cart != null)
      return this.cart.filter(itm => itm.seatedTicket && itm.eventId == this.eventId && itm.isSeason == this.isSeason && itm.sectionName == code).length;
    return 0;
  }
    GetSelectedSeat() {        
        if (this.selectedSeat === null || this.selectedSeat === undefined) {
            this.selectedSeat = this.cart[0];
        } 
        return this.selectedSeat;
    }

    GetSelectedSeatIndex() {
        if (this.selectedSeat === null || this.selectedSeat === undefined) {
            return 0;            
        }
      return Math.max(0, this.GetCart().findIndex(obj => obj.id === this.selectedSeat.id));        
    }



    SetConfirmedSeat(seatid) {        
        this._confirmedSeats.splice(this._confirmedSeats.indexOf(seatid), 1);
        this._confirmedSeats.push(seatid);        
    }


 /* PRIVATE FUNKTIONS */
/*--------------------------------------------------------------*/

    _loadBasket() {
        return $.ajax({
            headers: {
                'Accept': 'application/json, text/plain, */*',
                'Content-Type': 'application/json'
            },
            dataType: 'json',
            url: C.BASE_URL + C.CART_DATA_URL,
        });       
    }


};